var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 18.9844V15.1578C20.0312 13.6348 21.2773 12.3887 22.8003 12.3887H37.1997C38.7227 12.3887 39.9688 13.6348 39.9688 15.1578V18.9844",
    stroke: "#F38D00",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9922 31.3594V46.0332C48.9922 47.4509 47.8318 48.6113 46.4141 48.6113H13.5859C12.1682 48.6113 11.0078 47.4512 11.0078 46.0332V31.4453",
    stroke: "#F38D00",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 35.6992C17.4713 35.1794 9.28906 32.5797 9.28906 27.9001V21.7988C9.28906 20.3789 10.4472 19.2207 11.8672 19.2207H48.1328C49.5528 19.2207 50.7109 20.379 50.7109 21.7988V27.9001C50.7109 32.609 42.4254 35.2119 33.2656 35.7088",
    stroke: "#F38D00",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8203 33.1426H33.1797V36.1074C33.1797 37.7381 31.8455 39.0723 30.2148 39.0723H29.7852C28.1545 39.0723 26.8203 37.7381 26.8203 36.1074V33.1426Z",
    stroke: "#F38D00",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeg);
export default __webpack_public_path__ + "static/media/beg.51f78163d1d71a437e9dfab798e2ccf3.svg";
export { ForwardRef as ReactComponent };